import React from "react";
import './talktoexperts.css';

import ExpertImage from "../assets/Ellipse 1829.png";

const TalkToExperts = () => {
    return (
        <div className="talk-to-experts-container">
            <div className="sectiontitle"> Talk To Our Visa <span>Experts</span></div>
            <div className="talk-to-experts-grid">
                <div className="talk-to-experts-card">
                    <img src={ExpertImage}></img>
                    <div>John Doe</div>
                    <div>8832838389389</div>
                </div>

                <div className="talk-to-experts-card">
                    <img src={ExpertImage}></img>
                    <div>John Doe</div>
                    <div>8832838389389</div>
                </div>
            </div>
        </div>
    )
}

export default TalkToExperts